import { Tabs, Text } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate } from "react-router-dom";

import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { PROXY_EVENTS_TABS } from "src/constants/tabs";

export function ProxyEvents() {
  const navigate = useNavigate();
  const match = useMatch(`/proxy-events/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/proxy-events/${value}`);
  };

  return (
    <PageContainer>
      <Text variant="h4" sx={{ pb: 4, pt: 10, px: 10 }}>
        Proxy Events
      </Text>
      <Box sx={{ mx: 10 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "voting"}
          clickHandler={handleTabChange}
          tabs={PROXY_EVENTS_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
